// extracted by mini-css-extract-plugin
export default {"container":"ConnectWalletModal_container__-xbdx"};